<template>
    <nav class="navbar">
        <div class="navbar__inner container">
            <div class="navbar__menu">
                <nav-menu
                    v-if="isLoggedIn"
                    :policies="policies">
                </nav-menu>
            </div>

            <div class="navbar__brand" v-if="!disable_dsw">
                <a :href="route('dashboard')">
                    <img src="/images/logo.svg" class="navbar__logo"/>
                </a>
            </div>

            <div class="navbar__brand" v-if="logo_src">
                <a :href="route('dashboard')">
                    <img :src="logo_src" class="navbar__logo"/>
                </a>
            </div>

            <div class="navbar__user">
                <nav-user
                    v-if="isLoggedIn"
                    :can-imitate-login="policies.imitateLogin"
                    :full-name="fullName">
                </nav-user>
            </div>
        </div>
    </nav>
</template>

<script>
import { EventBus } from '../eventbus';

export default {
    props: [
        'isLoggedIn',
        'fullName',
        'policies',
    ],

    data() {
        return {
            logo_src: window.sw3.theme.logo_src,
            disable_dsw: window.sw3.theme.disable_default_logo,
        };
    },

     methods: {
        fetchLogoVariables() {
            axios.get(this.route('mainapi.tenants.logo_vars')).then((response) => {
                this.logo_src = response.data.data.logo_src;
                this.disable_dsw = response.data.data.disable_dsw_logo;
            });
        },
     },

    mounted() {
        // Connect to selected tenant database
        EventBus.$on('databaseChanged', () => {
            this.fetchLogoVariables();
        });
    },
}
</script>
